
const defaultUi = {
  showArrival: true,
  showEstimateArrival: true,
  showSite: true,
  showExit: true,
  showCarSection: true,
  showNumCC: false,
  showYearsOnMic: false,
  showShoesSize: true,
  shirtSizeMenOnly: false,
  showDayOfArrival: true,
  showDayOfExit: true,
  showHelpLeaveFrom: true
}

const eventConfig = {
  1: {
    // MICFootball
    descriptionKey: 'info_volunteer_arrival.micfootball.description',
    day_of_arrival: [
      { key: '2026-03-29', value: 'calendar.days.sunday' },
      { key: '2026-03-30', value: 'calendar.days.monday' },
      { key: '2026-03-31', value: 'calendar.days.tuesday' },
      { key: 'others', value: 'info_volunteer_arrival.micfootball.day_of_arrival.others' }
    ],
    arrival_site: [
      { key: 'manga', value: 'info_volunteer_arrival.micfootball.arrival_site.manga' },
      { key: 'hotel', value: 'info_volunteer_arrival.micfootball.arrival_site.hotel' },
      { key: 'camp', value: 'info_volunteer_arrival.micfootball.arrival_site.camp' }
    ],
    day_of_exit: [
      { key: '2025-04-05', value: 'calendar.days.sunday' },
      { key: 'others', value: 'info_volunteer_arrival.micfootball.day_of_arrival.others' }
    ],
    estimate_arrival: [
      { key: 'morning', value: 'morning' },
      { key: 'afternoon', value: 'afternoon' },
      { key: 'night', value: 'night' }
    ],
    contract: [],
    ui: {
      ...defaultUi,
      showYearsOnMic: true
    },
    manuals: [
      {
        titleKey: 'volunteers.event_manual_hotel',
        urlTemplate: 'manuals/micfootball_hotel_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_manual_camps',
        urlTemplate: 'manuals/micfootball_camps_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_dossier_fisio',
        urlTemplate: 'manuals/micfootball_fisio_{edition}.pdf'
      }
    ]
  },

  2: {
    // MICFootball7
    descriptionKey: 'info_volunteer_arrival.micfootball7.description',
    day_of_arrival: [
      { key: '2026-06-12', value: 'info_volunteer_arrival.micfootball7.day_of_arrival.friday' },
      { key: '2026-06-13', value: 'info_volunteer_arrival.micfootball7.day_of_arrival.saturday' }
    ],
    arrival_site: [
      { key: 'training', value: 'info_volunteer_arrival.micfootball7.arrival_site.training' },
      { key: 'hotel', value: 'info_volunteer_arrival.micfootball7.arrival_site.hotel' },
      { key: 'installation', value: 'info_volunteer_arrival.micfootball7.arrival_site.installation' }
    ],
    day_of_exit: [
      { key: '2026-06-14', value: 'calendar.days.sunday' }
    ],
    estimate_arrival: [
      { key: 'morning', value: 'morning' },
      { key: 'afternoon', value: 'afternoon' },
      { key: 'night', value: 'night' }
    ],
    contract: [],
    ui: {
        showArrival: true,
        showEstimateArrival: false,
        showSite: false,
        showExit: true,
        showCarSection: true,
        showNumCC: false,
        showYearsOnMic: false,
        showShoesSize: false,
        shirtSizeMenOnly: false,
        showDayOfArrival: true,
        showDayOfExit: true,
        showHelpLeaveFrom: true
    },
    manuals: [
      {
        titleKey: 'volunteers.event_dossier',
        urlTemplate: 'manuals/micfootball7_{edition}.pdf'
      }
    ]
  },

  3: {
    // MICBasketball
    descriptionKey: 'info_volunteer_arrival.micbasketball.description',
    day_of_arrival: [
      { key: '2020-04-05', value: 'info_volunteer_arrival.micbasketball.day_of_arrival.sunday' },
      { key: '2020-04-06', value: 'info_volunteer_arrival.micbasketball.day_of_arrival.monday' },
      { key: '2020-04-07', value: 'info_volunteer_arrival.micbasketball.day_of_arrival.tuesday' },
      { key: '2020-04-08', value: 'info_volunteer_arrival.micbasketball.day_of_arrival.wednesday' },
      { key: '2020-04-09', value: 'info_volunteer_arrival.micbasketball.day_of_arrival.thursday' }
    ],
    arrival_site: [
      { key: 'training', value: 'info_volunteer_arrival.micbasketball.arrival_site.training' },
      { key: 'airport', value: 'info_volunteer_arrival.micbasketball.arrival_site.airport' },
      { key: 'sants', value: 'info_volunteer_arrival.micbasketball.arrival_site.sants' }
    ],
    day_of_exit: [],
    estimate_arrival: [
      { key: 'morning', value: 'morning' },
      { key: 'afternoon', value: 'afternoon' },
      { key: 'night', value: 'night' }
    ],
    contract: [],
    ui: {
      ...defaultUi
    },
    manuals: [
      {
        titleKey: 'volunteers.event_dossier',
        urlTemplate: 'manuals/DOSSIER_MICBasket_{edition}.pdf'
      }
    ]
  },

  4: {
    // MIC CAMP
    descriptionKey: 'info_volunteer_arrival.miccampand.description',
    day_of_arrival: [{ key: '2026-07-05', value: 'calendar.days.sunday' }],
    arrival_site: [],
    day_of_exit: [{ key: '2026-07-11', value: 'calendar.days.saturday' }],
    estimate_arrival: [
      { key: 'morning', value: 'morning' }
    ],
    contract: [],
    ui: {
      ...defaultUi,
      showDayOfArrival: true,
      showDayOfExit: true,
      showSite: false,
      shirtSizeMenOnly: false
    },
    manuals: [
      {
        titleKey: 'volunteers.event_dossier_fisio',
        urlTemplate: 'manuals/DOSSIER_MICCAMP_AND_fisio_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_dossier_lleure',
        urlTemplate: 'manuals/DOSSIER_MICCAMP_AND_lleure_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_dossier_monitor',
        urlTemplate: 'manuals/DOSSIER_MICCAMP_AND_monitor_{edition}.pdf'
      }
    ]
  },

  5: {
    // Pau Gasol Academy
    descriptionKey: 'info_volunteer_arrival.pau-gasol-academy.description',
    day_of_arrival: [
      { key: '2023-07-01', value: 'info_volunteer_arrival.pau-gasol-academy.day_of_arrival.saturday' },
      { key: '2023-07-02', value: 'info_volunteer_arrival.pau-gasol-academy.day_of_arrival.sunday' }
    ],
    arrival_site: [
      { key: 'sants', value: 'info_volunteer_arrival.pau-gasol-academy.arrival_site.sants' },
      { key: 'formacion', value: 'info_volunteer_arrival.pau-gasol-academy.arrival_site.formacions' },
      { key: 'aeroport', value: 'info_volunteer_arrival.pau-gasol-academy.arrival_site.aeroport' }
    ],
    day_of_exit: [],
    estimate_arrival: [
      { key: 'morning', value: 'morning' },
      { key: 'afternoon', value: 'afternoon' },
      { key: 'night', value: 'night' }
    ],
    contract: [
      { key: 'info_volunteer_contract.autonum', value: 'info_volunteer_contract.autonum' },
      { key: 'info_volunteer_contract.laboral', value: 'info_volunteer_contract.laboral' }
    ],
    ui: {
      ...defaultUi,
      showExit: false,
      showNumCC: true,
      showHelpLeaveFrom: false,
      shirtSizeMenOnly: true
    }
  },

  // Events without specific logic fall back to defaults
  6: { // Eurockey
    descriptionKey: '', day_of_arrival: [], arrival_site: [], day_of_exit: [], estimate_arrival: [], contract: [], ui: { ...defaultUi }
  },
  7: { // La Liga Genuine
    descriptionKey: '', day_of_arrival: [], arrival_site: [], day_of_exit: [], estimate_arrival: [], contract: [], ui: { ...defaultUi }
  },
  8: { // Mundo Deportivo Futcamp
    descriptionKey: '',
    day_of_arrival: [],
    arrival_site: [],
    day_of_exit: [],
    estimate_arrival: [],
    contract: [
      { key: 'info_volunteer_contract.autonum', value: 'info_volunteer_contract.autonum' },
      { key: 'info_volunteer_contract.laboral', value: 'info_volunteer_contract.laboral' }
    ],
    ui: { ...defaultUi }
  },
  9: { // DNC
    descriptionKey: '', day_of_arrival: [], arrival_site: [], day_of_exit: [], estimate_arrival: [], contract: [], ui: { ...defaultUi }
  },
  10: { // Trials
    descriptionKey: '', day_of_arrival: [], arrival_site: [], day_of_exit: [], estimate_arrival: [], contract: [], ui: { ...defaultUi }
  },
  11: { // Altres
    descriptionKey: '', day_of_arrival: [], arrival_site: [], day_of_exit: [], estimate_arrival: [], contract: [], ui: { ...defaultUi }
  },

  12: { // MICCAMP BCN
    descriptionKey: 'info_volunteer_arrival.miccampbcn.description',
    day_of_arrival: [{ key: '2026-06-29', value: 'calendar.days.monday' }],
    arrival_site: [],
    day_of_exit: [],
    estimate_arrival: [{ key: 'morning', value: 'morning' }],
    contract: [
      { key: 'info_volunteer_contract.autonum', value: 'info_volunteer_contract.autonum' },
      { key: 'info_volunteer_contract.laboral', value: 'info_volunteer_contract.laboral' }
    ],
    ui: { ...defaultUi, showNumCC: true, showArrival: true, showSite: false, showExit: false, shirtSizeMenOnly: false },
    manuals: [
      {
        titleKey: 'volunteers.event_dossier_fisio',
        urlTemplate: 'manuals/DOSSIER_MICCAMP_BCN_fisio_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_dossier_monitor',
        urlTemplate: 'manuals/DOSSIER_MICCAMP_BCN_monitor_{edition}.pdf'
      }
    ]
  },
  13: { // MundoDeportivo FUTCAMP
    descriptionKey: 'info_volunteer_arrival.mdfutcamp.description',
    day_of_arrival: [{ key: '2026-07-06', value: 'calendar.days.monday' }],
    arrival_site: [],
    day_of_exit: [],
    estimate_arrival: [{ key: 'morning', value: 'morning' }],
    contract: [
      { key: 'info_volunteer_contract.autonum', value: 'info_volunteer_contract.autonum' },
      { key: 'info_volunteer_contract.laboral', value: 'info_volunteer_contract.laboral' }
    ],
    ui: { ...defaultUi, showNumCC: true, showArrival: true, showSite: false, showExit: false, shirtSizeMenOnly: false }
  },

  14: { // MICFootfem
    descriptionKey: '', 
    day_of_arrival: [
        { key: '2026-06-12', value: 'calendar.days.friday' },
        { key: '2026-06-13', value: 'calendar.days.saturday' },
    ], arrival_site: [], 
    day_of_exit: [
        { key: '2026-06-14', value: 'calendar.days.sunday' },
    ],
    estimate_arrival: [], contract: [], ui: {
        showArrival: true,
        showEstimateArrival: false,
        showSite: false,
        showExit: true,
        showCarSection: true,
        showNumCC: false,
        showYearsOnMic: false,
        showShoesSize: false,
        shirtSizeMenOnly: false,
        showDayOfArrival: true,
        showDayOfExit: true,
        showHelpLeaveFrom: true
      }
  },

  15: { // MICFootball Punta Cana
    descriptionKey: 'info_volunteer_arrival.micfootball-punta-cana.description',
    day_of_arrival: [
      { key: '2025-06-23', value: 'info_volunteer_arrival.micfootball-punta-cana.day_of_arrival.monday' },
      { key: '2025-06-24', value: 'info_volunteer_arrival.micfootball-punta-cana.day_of_arrival.tuesday' },
      { key: 'others', value: 'info_volunteer_arrival.micfootball-punta-cana.day_of_arrival.others' }
    ],
    arrival_site: [
      { key: 'manga', value: 'info_volunteer_arrival.micfootball-punta-cana.arrival_site.manga' },
      { key: 'hotel', value: 'info_volunteer_arrival.micfootball-punta-cana.arrival_site.hotel' },
      { key: 'camp', value: 'info_volunteer_arrival.micfootball-punta-cana.arrival_site.camp' }
    ],
    day_of_exit: [
      { key: '2025-06-29', value: 'info_volunteer_arrival.micfootball-punta-cana.day_of_exit.sunday' },
      { key: 'others', value: 'info_volunteer_arrival.micfootball-punta-cana.day_of_exit.others' }
    ],
    estimate_arrival: [
      { key: 'morning', value: 'morning' },
      { key: 'afternoon', value: 'afternoon' }
    ],
    contract: [],
    ui: { ...defaultUi, showShoesSize: false, showHelpLeaveFrom: false, showEstimateArrival: false },
    manuals: [
      {
        titleKey: 'volunteers.event_manual_tasks',
        urlTemplate: 'manuals/micfootballpuntacana_tasks_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_manual_guides',
        urlTemplate: 'manuals/micfootballpuntacana_guides_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_dossier_director_helpers',
        urlTemplate: 'manuals/micfootballpuntacana_director_helpers_{edition}.pdf'
      },
      {
        titleKey: 'volunteers.event_manual_hotel',
        urlTemplate: 'manuals/micfootballpuntacana_hotel_{edition}.pdf'
      }
    ]
  },
  16: { // Aitana
    descriptionKey: '', 
    day_of_arrival: [
        { key: '2026-07-19', value: 'calendar.days.sunday' }
    ], arrival_site: [], 
    day_of_exit: [
        { key: '2026-07-25', value: 'calendar.days.saturday' }
    ],
    estimate_arrival: [], contract: [], ui: {
        showArrival: true,
        showEstimateArrival: false,
        showSite: false,
        showExit: true,
        showCarSection: false,
        showNumCC: false,
        showYearsOnMic: false,
        showShoesSize: false,
        shirtSizeMenOnly: false,
        showDayOfArrival: true,
        showDayOfExit: true,
        showHelpLeaveFrom: true
      }
  },
}

export default eventConfig
